import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  dis_dur:{
    color: "black",
    fontSize: "14px !important",
    display: "flex",
    justifyContent: "space-around",
  },
}));

export default useStyles;
